export default __webpack_public_path__ + "static/img-nba-top-shot-aab1f215ef33b320755312edf3871da6.png";